<script setup lang="ts">
withDefaults(defineProps<{
  size?: "sm" | "md" | "lg";
}>(), {
  size: "md",
});

const sizeClasses = {
  sm: "p-3",
  md: "p-4",
  lg: "p-5",
};

const iconSizeClasses = {
  sm: "size-8",
  md: "size-10",
  lg: "size-12",
};
</script>

<template>
  <div
    :class="[
      'absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-primary-600/80 opacity-70 shadow-lg transition-all group-hover:scale-110 group-hover:bg-primary-500 group-hover:opacity-100',
      sizeClasses[size],
    ]"
  >
    <Icon
      name="lucide:play"
      :class="[
        'text-white',
        iconSizeClasses[size],
      ]"
    />
  </div>
</template>
